<script>
import {Tooltip} from "bootstrap";

export default {
  name: "AbstractAtom",
  mounted() {
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    });
  }
}
</script>
